module.exports = __webpack_public_path__ + "static/media/axe.87541e8e.svg";